import React, { useState, useEffect } from "react";
import { StyleSheet, Animated } from "react-native";

export default function Collapsible({ children, isCollapsed }) {
  const [fadeAnim] = useState(new Animated.Value(0));

  useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: isCollapsed ? 0 : 50000,
      duration: isCollapsed ? 0 : 250,
      useNativeDriver: false
    }).start();
  }, [isCollapsed]);

  return (
    <Animated.View style={[styles.content, { maxHeight: fadeAnim }]}>
      {children}
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  content: {
    overflow: "hidden",
    height: "auto",
  },
});
